import { createApiAction, createAction } from '@saucelabs/sl-util-redux';

import types from './types';
import api from './api';
import lsmSocket from './lsmSocket';
import utils from './utils';
import constants from './constants';

const createSession = createApiAction(
  types.LSM_SESSION_CREATE,
  (payload, meta, dispatch, getState) => (
    api
      .createSession(utils.createCapabilitiesFromFormData(payload, getState().user.get('username')))
      .then(({ data }) => data)
  ),
  { meta: { skipErrorPage: true } },
);

const getChannelStatusRequest = (sessionId) => api.getChannelStatus(sessionId);
const getChannelStatusFailure = createAction(types.LSM_CHANNEL_STATUS_GET.FAILURE);

const connectChannel = createApiAction(
  types.LSM_CHANNEL_CONNECT,
  async (sessionId, meta, dispatch) => {
    try {
      const {
        capabilities,
        rfb: rfbPath,
        seconds_left: secondsLeft,
        tunnel,
      } = await lsmSocket.connectChannel(sessionId, dispatch);
      return { capabilities, rfbPath, secondsLeft, tunnel };
    } catch (error) {
      // map a closed socket to what the getChannelStatus API call would return for a GONE session
      if (error.channelStatus === constants.SOCKET_STATES.COMPLETE) {
        error.response = { status: 410 };
      }
      throw error;
    }
  },
  { meta: { skipErrorPage: true } },
);

const getSessionInfo = createApiAction(
  types.LSM_GET_SESSION_INFO,
  (sessionId) => api.getSessionInfo(sessionId),
  { meta: { skipErrorPage: true } },
);

const takeScreenshot = createApiAction(
  types.LSM_GET_SCREENSHOT,
  () => lsmSocket.takeScreenshot(),
  { meta: { skipErrorPage: true } },
);

const secondsLeftUpdate = createAction(types.LSM_SECONDS_LEFT_UPDATE);

const closeSession = createApiAction(
  types.LSM_SESSION_CLOSE,
  () => lsmSocket.stopSession(),
  { meta: { skipErrorPage: true } },
);
const sessionIsClosed = createAction(types.LSM_SESSION_CLOSE.SUCCESS);

const reconnectionRequest = createAction(types.LSM_SESSION_RECONNECT.REQUEST);
const reconnectionSuccess = createAction(types.LSM_SESSION_RECONNECT.SUCCESS);
const reconnectionFailure = createAction(types.LSM_SESSION_RECONNECT.FAILURE);

export default {
  createSession,
  closeSession,
  connectChannel,
  getChannelStatusRequest,
  getChannelStatusFailure,
  getSessionInfo,
  reconnectionRequest,
  reconnectionSuccess,
  reconnectionFailure,
  secondsLeftUpdate,
  sessionIsClosed,
  takeScreenshot,
};
